import { useMemo } from "react";
import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns, MinAvgMaxKeys } from "@repo/utils";
import { getProfitColor } from "@utils";
import { useEstimateEditorSettings, useEstimateStructure, ValueCell } from "@tools";
import { useTheme } from "@material-ui/core/styles";

export const ProfitCell = observer(({
  element,
  displayCellContent,
  ...props
}) => {
  const theme = useTheme();
  const { allowEdition } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  const { showFixedDecimalPrices } = structure;
  const { currencyObj, roundPrice, priceFormat, maxValuesAsBuffer } = structure.settings;
  const { displayCompanyProfit, displayCompanyProfitMax, showMaxCompanyProfit, companyProfitability } = element;
  
  const color = useMemo(() => (
    getProfitColor(companyProfitability, theme)
  ), [companyProfitability, theme]);

  const handleCompanyProfitChange = (profit, isMax) => {
    let key = MinAvgMaxKeys.AVG;
    if(isMax)
      key = MinAvgMaxKeys.MAX;
    else if(!maxValuesAsBuffer && showMaxCompanyProfit)
      key = MinAvgMaxKeys.MIN;
    
    element.setCompanyProfit(profit, key);
  };
  
  return (
    <ValueCell
      colName={ SummaryColumns.C_PROFIT }
      useDynamicWidth
      fullWidthInputs
      displayContent={displayCellContent}
      value={displayCompanyProfit}
      valueMax={displayCompanyProfitMax}
      displayMax={showMaxCompanyProfit}
      onValueChange={handleCompanyProfitChange}
      editable={ maxValuesAsBuffer ? { min: allowEdition } : allowEdition }
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      showDecimals={!roundPrice}
      fixedDecimalScale={showFixedDecimalPrices}
      allowNegative
      max={10000000}
      style={{color}}
      inputClassName="input-profit"
      applySuffixSpacing
      { ...props }
    />
  );
});

ProfitCell.propTypes = {
  element: object.isRequired,
  displayCellContent: bool,
  extendPadding: bool,
};
